import { AxiosResponse } from 'axios';
import { store } from 'core';

import { requestCache } from './cache';

import { forceUpdateAction } from 'core/rootReducer';

const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000; // 90 days in milliseconds

export const responseInterceptor = async (response: AxiosResponse) => {
  const { baseURL, data, method, url, params } = response.config;

  if (requestCache.has(JSON.stringify({ baseURL, data, method, url, params }))) {
    requestCache.delete(JSON.stringify({ baseURL, data, method, url, params }));
  }

  if (response.status === 200) {
    const currentAppVersion = localStorage.getItem('designerAppVersion');
    const appVersion = response.headers['designer-min-app-version'];
    const lastUpdateTime = localStorage.getItem('designerAppVersionTimestamp');

    // Reset version if it's older than 90 days or if there's no timestamp
    const shouldResetVersion =
      !lastUpdateTime || Date.now() - parseInt(lastUpdateTime, 10) > NINETY_DAYS_MS;

    if (appVersion && (shouldResetVersion || currentAppVersion !== appVersion)) {
      localStorage.setItem('designerAppVersion', appVersion);
      localStorage.setItem('designerAppVersionTimestamp', Date.now().toString());

      store.dispatch(forceUpdateAction(true));
    }
  }
  return response;
};
